import React, { useState, useEffect, useRef } from "react";
import { API_URL, getValFromLS } from "../helpers";
import Alert from "../components/Alert";
import Input from "../components/Input";
import Textarea from "../components/Textarea";
import Msg from "../components/Msg";
import Submit from "../components/Submit";

const Form1 = ({ update }) => {
	const [errors, setErrors] = useState([]);
	const [names, setNames] = useState({});
	const [msg, setMsg] = useState({});
	const [alert, setAlert] = useState({
		type: "working",
		text: "",
	});

	const formElement = useRef(null);

	useEffect(() => {
		init();

		// eslint-disable-next-line
	}, []);

	const init = async () => {
		const token = getValFromLS("friendsDash", true)
			? getValFromLS("friendsDash", true)
			: "";

		const url = new URL(`${API_URL}/auth/friendsDashForm1Init`);
		const params = {
			token,
		};
		url.search = new URLSearchParams(params);

		try {
			const response = await fetch(url, {
				method: "GET",
				cache: "no-store",
			});
			const json = await response.json();
			if (json && json.resp === 1) {
				handleUpdate("text", json.text);
				handleUpdate("goal", json.goal);
				setAlert({});
			} else {
				setAlert({
					type: "error",
					text: json.text,
				});
			}
		} catch (error) {
			setAlert({
				type: "error",
				text: "An error has occurred.",
			});
		}
	};

	const handleUpdate = (name, value) => {
		setNames((names) => ({ ...names, [name]: value ? value : "" }));
	};

	const handleSubmit = async (e) => {
		e.preventDefault();
		setErrors([]);
		setMsg({
			type: "working",
			text: "",
		});

		const url = new URL(`${API_URL}/auth/friendsDashForm1`);
		let formData = new FormData();
		Object.entries(names).forEach(([key, value]) => {
			formData.append(key, value);
		});
		formData.append("token", getValFromLS("friendsDash", true));

		try {
			const response = await fetch(url, {
				method: "POST",
				body: formData,
			});
			const json = await response.json();
			if (json && json.resp === 1) {
				//update("form", 0);
				window.location.reload();
			} else {
				setErrors(json.fields);
				setMsg({
					type: "error",
					text: json.text,
				});
			}
		} catch (error) {
			setMsg({
				type: "error",
				text: "An error has occurred.",
			});
		}
	};

	return (
		<>
			{alert.type ? (
				<Alert data={alert} />
			) : (
				<form
					ref={formElement}
					method="post"
					action="/"
					onSubmit={(e) => handleSubmit(e)}
					className="well"
				>
					<h3 style={{ marginTop: "0" }}>Fundraising Story & Goal</h3>

					<p>
						Use this form to customize your story and fundraising goal amount
						that will appear to donors on your public-facing fundraising page.
					</p>

					<div className="form-group one">
						<Textarea
							name="text"
							label="Your Story"
							reqd={true}
							value={names.text || ""}
							update={handleUpdate}
							errors={errors}
						/>
					</div>

					<div className="form-group">
						<Input
							name="goal"
							label="Fundraising Goal for 2026-2027 Campaign ($)"
							reqd={true}
							value={names.goal || ""}
							autocomplete="off"
							update={handleUpdate}
							errors={errors}
							addonIcon="fa-dollar-sign"
						/>
						<div />
					</div>

					<div className="msg-submit">
						{msg.type && <Msg data={msg} />}

						<div
							className={
								msg.type === "working" || msg.type === "success"
									? "hidden"
									: "submit-container"
							}
						>
							<Submit path="" left="" submit="Submit Updates" />
						</div>
					</div>
				</form>
			)}
		</>
	);
};

export default Form1;
